exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.row-item-transparent-with-border[data-v-4aef7462]{padding:58px 0;cursor:pointer}.envelope-container[data-v-4aef7462]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.envelope[data-v-4aef7462]{margin:auto}", ""]);

// exports
